var _defs, _style, _circle, _line, _line2, _line3, _line4, _circle2, _circle3, _circle4, _text, _text2, _text3, _text4, _text5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallMounting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 12,
    markerHeight: 12,
    refX: 6,
    refY: 6,
    orient: "auto",
    markerUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 12,6 0,12",
    fill: "blue"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .thick { stroke: black; stroke-width: 6; fill: none; }\n    .arrow { stroke: blue; stroke-width: 2; fill: none; marker-end: url(#arrowhead); }\n    .blue-dot { fill: blue; stroke: none; }\n    .black-dot { fill: black; stroke: none; }\n    .label { fill: blue; font-size: 14px; font-family: sans-serif; }\n    .center-text { fill: blue; font-size: 32px; font-family: sans-serif; text-anchor: middle; dominant-baseline: middle; }\n    .bold { font-weight: bold; }\n  ")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "thick",
    cx: 150,
    cy: 150,
    r: 80
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "thick",
    x1: 150,
    y1: 230,
    x2: 150,
    y2: 270
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 150,
    y2: 310
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 10,
    y2: 150
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "arrow",
    x1: 150,
    y1: 150,
    x2: 290,
    y2: 150
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "blue-dot",
    cx: 150,
    cy: 150,
    r: 9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "black-dot",
    cx: 150,
    cy: 90,
    r: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "black-dot",
    cx: 158,
    cy: 98,
    r: 1.2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 10,
    y: 140
  }, "xMax")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 275,
    y: 140
  }, "xMin")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 160,
    y: 310
  }, "yMax")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 162,
    y: 162
  }, "yMin = 0")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "center-text",
    x: 150,
    y: 122
  }, "\n    care", /*#__PURE__*/React.createElement("tspan", {
    className: "bold"
  }, "4"), "u\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallMounting);
export default __webpack_public_path__ + "static/media/wall_mounting.bb62b25e9c5a3637d2a848158507e6f2.svg";
export { ForwardRef as ReactComponent };